import React, { FC, useEffect, useState } from 'react';
import { Field, useFormikContext } from 'formik';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import { useLocale } from '../../contexts/localeContext';
import { validateItemName } from '../../utilities/Validation';

interface DescriptionProps {
    title: string;
    maxLength?: number;
    modalDescription?: boolean;
    isRequired?: boolean;
    accessor?: string;
    /**
     * Strictly written as Tailwind CSS height classes like 'h-32', 'h-64' etc.
     */
    height?: string;
    remainingCharactersClass?: string;
}

const Description: FC<DescriptionProps> = ({ title = "Description", maxLength = 64, modalDescription, isRequired = false, accessor = "description", height = modalDescription ? "h-64" : "h-32", remainingCharactersClass = '' }) => {
    const { values, setFieldValue } = useFormikContext<any>();
    const [fieldLength, setFieldLength] = useState<number>(0);
    const alphaNumericRegex = /[\W\S]/;
    const specialKeys: string[] = ['Backspace', 'Tab', ' '];
    const { translate } = useLocale();

    useEffect(() => {
        setFieldLength(values[accessor] ? values[accessor].length : 0);
        checkCopyAndPasteCharacters(accessor ? values[accessor] : "");
    }, [values[accessor]])

    const blockOrAllowKey = (event) => {
        if (specialKeys.includes(event.key)) {

        }
        else if (maxLength === event.target.value.length) {
            event.preventDefault();
        }
        else if (event.key.match(alphaNumericRegex)) {

        }
        else {
            event.preventDefault();
        }
    }

    const updateLength = (event) => {
        if (event.key.match(alphaNumericRegex) && event.target.value.length <= maxLength) {
            setFieldLength(event.target.value.length)
        }
    }

    const checkCopyAndPasteCharacters = (descriptionText) => {
        if (descriptionText && descriptionText.length > 64) {
            const splitDescriptionText = descriptionText.substring(0, maxLength);
            setFieldValue(accessor, splitDescriptionText);
        }
    }

    return <>
        <div className="w-full overflow-visible">
            {title !== '' ?
                modalDescription ?
                    <span className="text-sm"><b>{title}</b></span>
                    :
                    <div className={`mb-3 text-portal-blue-primary text-xl font-semibold`}>{title}</div> : null
            }
            <Field
                name={accessor}
                component="textarea"
                data-cy="descriptionField"
                className={`border w-full ${height} px-2 py-1`}
                onKeyDown={(event) => blockOrAllowKey(event)}
                onKeyUp={(event) => updateLength(event)}
                validate={isRequired ? validateItemName : ""}
            />
            <span className={remainingCharactersClass}>{maxLength - fieldLength} {translate.byKey(TranslationKeys.remainingCharacters)}</span>
        </div>
    </>;
};

export default Description;
